import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBooks } from "../../redux/reducers/booksSlice";
import { useNavigate } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [done, setDone] = useState(false);

  const { data: books } = useSelector((state) => state.books);

  useEffect(() => {
    if (books.length === 0) {
      dispatch(fetchBooks());
    }
  }, [dispatch, books.length]);

  const oldTestamentBooks = books.filter((book) => book.testament === "OT");
  const newTestamentBooks = books.filter((book) => book.testament === "NT");

  const handleBookClick = (bookId) => {
    navigate(`/bible/book/${bookId}`);
  };

  return (
    <main className="font-bembo flex flex-1 w-full flex-col items-center justify-center text-center px-4 sm:mt-28 mt-20">
      <br />
      <h1 className="mx-auto max-w-4xl font-display text-5xl font-bold tracking-normal text-slate-900 sm:text-7xl">
        {done ? (
          "BIBLIA"
        ) : (
          <Typewriter
            words={["BIBLIA"]}
            loop={1}
            cursor
            cursorStyle="|"
            typeSpeed={80}
            deleteSpeed={40}
            delaySpeed={1000}
            onLoopDone={() => setDone(true)}
          />
        )}
      </h1>
      <h3 className="mx-auto max-w-1xl font-display text-2xl font-bold tracking-normal text-slate-900 sm:text-4xl">
        Reina Valera 1960
      </h3>

      <div className="mt-10">
        <h2 className="text-3xl font-semibold mb-4 text-slate-700">
          Antiguo Testamento
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-6 gap-3">
          {oldTestamentBooks.map((book) => (
            <button
              key={book.id}
              type="button"
              id={`ot-book-${book.id}`}
              onClick={() => handleBookClick(book.id)}
              className="py-1.5 px-2.5 bg-white text-black hover:bg-black hover:text-white rounded-xl shadow-md transition"
            >
              {book.name}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-10">
        <h2 className="text-3xl font-semibold mb-4 text-slate-700">
          Nuevo Testamento
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-6 gap-3">
          {newTestamentBooks.map((book) => (
            <button
              key={book.id}
              type="button"
              id={`nt-book-${book.id}`}
              onClick={() => handleBookClick(book.id)}
              className="py-1.5 px-2.5 bg-white text-black hover:bg-black hover:text-white rounded-xl shadow-md transition"
            >
              {book.name}
            </button>
          ))}
        </div>
      </div>
      <br />
      <br />
      <br />
    </main>
  );
}

export default Header;
